import React from 'react';
import { AlertTriangleIcon, BoxIcon, ClipboardListIcon, FileTextIcon, HeartHandshakeIcon, ListOrderedIcon, PrinterIcon } from 'lucide-react';
import { features } from '../data/content';
import { SectionHeading } from './SectionHeading';
const icons: Record<(typeof features.items)[number]['icon'], BoxIcon> = {
  consent: FileTextIcon,
  tray: ClipboardListIcon,
  steps: ListOrderedIcon,
  flag: AlertTriangleIcon,
  patient: HeartHandshakeIcon,
  print: PrinterIcon
};
export function FeaturesSection() {
  return <section aria-labelledby="features-title" className="bg-cream py-12 md:py-20" data-id="element-48" data-mp="1ma91k51d67nr">
      <div className="mx-auto max-w-page px-5 md:px-8" data-id="element-49" data-mp="200w09x74jxju">
        <SectionHeading id="features-title" title={features.title} sub={features.sub} data-id="element-50" data-mp="1v9mbszxbb09j" />

        <ul className="mt-8 grid gap-3 sm:grid-cols-2 md:mt-12 md:gap-4 lg:grid-cols-3" data-id="element-51" data-mp="17js04loqbhqv">
          {features.items.map(item => {
          const Icon = icons[item.icon];
          return <li key={item.title} className="flex gap-4 rounded-xl border border-cream-line bg-white p-5 md:p-6" data-id="element-52" data-mp="31bfj5d7to8z3">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-teal-tint text-teal" data-id="element-53" data-mp="36a8up03jtpwm">
                  <Icon className="h-5 w-5" strokeWidth={2} aria-hidden="true" data-id="element-54" data-mp="3b2a66jsw7cll" />
                </span>
                <div data-id="element-55" data-mp="3fzadey1halea">
                  <h3 className="font-display text-[16px] font-extrabold uppercase leading-snug tracking-tight text-teal" data-id="element-56" data-mp="3fzsdy6v6bls0">
                    {item.title}
                  </h3>
                  <p className="mt-1 text-[16px] leading-relaxed text-ink/75" data-id="element-57" data-mp="2ncpoe48h6ldw">{item.text}</p>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}